import { useNavigate } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';
import { Button } from '@tes/ui';
import { SigningLinks } from '../../components/SigningLinks';
import type { CreateEnvelopeResult } from '../../lib/types';

/**
 * After a send. n8n emails the link off the webhook; the copyable link is the
 * fallback for when that email doesn't arrive (or nobody is subscribed).
 */
export function SentView({
  result,
  emailReady,
  onAnother,
}: {
  result: CreateEnvelopeResult;
  /** false = no active webhook endpoint takes envelope.sent; undefined = unknown. */
  emailReady: boolean | undefined;
  onAnother: () => void;
}) {
  const navigate = useNavigate();
  const signer = result.signers[0];
  const count = result.documents.length;

  return (
    <div className="mx-auto max-w-xl py-10">
      <div className="mb-6 flex flex-col items-center text-center">
        <CheckCircle2 size={40} className="mb-3 text-emerald-500" />
        <h1 className="text-lg font-semibold">Sent to {signer?.name}</h1>
        <p className="mt-1 text-sm text-slate-500">
          {count} document{count === 1 ? '' : 's'} waiting for {signer?.email}.
        </p>
      </div>

      <SigningLinks signers={result.signers} tone={emailReady === false ? 'warn' : 'ok'}>
        {result.replayed
          ? 'This send had already gone through, and the link was emailed then. Use Resend links in Envelopes if it needs sending again.'
          : emailReady === false
            ? 'No webhook endpoint is subscribed to envelope.sent, so nobody will email this link. Copy it and send it yourself.'
            : "n8n is emailing the signing link now. If it doesn't arrive, copy it here and send it yourself."}
      </SigningLinks>

      <div className="mt-6 flex justify-center gap-2">
        <Button onClick={onAnother}>Send another</Button>
        <Button variant="outline" onClick={() => navigate('/envelopes')}>
          Go to Envelopes
        </Button>
      </div>
    </div>
  );
}
